import { render, staticRenderFns } from "./PaginatedSearchTable.vue?vue&type=template&id=73d74b10&"
import script from "./PaginatedSearchTable.vue?vue&type=script&lang=js&"
export * from "./PaginatedSearchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports